import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_34xfsouq90: FaireBrandEntity = {
  token: "b_34xfsouq90",
  type: "brand",
  name: "Martins Handmade Pretzels",
  avatarUrl:
    "https://cdn.faire.com/fastly/bd9faab9f7127b18a20a6a4d562ade1a3a0605a0dda1a3a064ad7e672b28be7d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f3206e079d5ea20651f6909c1c92569238a5dded4ec4499b1cd59b96c112a9ce.png",
  logoUrl:
    "https://cdn.faire.com/fastly/bd9faab9f7127b18a20a6a4d562ade1a3a0605a0dda1a3a064ad7e672b28be7d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f3206e079d5ea20651f6909c1c92569238a5dded4ec4499b1cd59b96c112a9ce.png",
  location: "Moira , NY, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 110,
  isTopShop: true,
  isInsider: true,
  description:
    "Finding a snack that is both delicious and made with simple, high-quality ingredients can be challenging…\n\nIn a world where convenience often trumps quality, we believe that you shouldn’t have to compromise on the integrity of the food you consume.\nWe're one of the last Handmade Pretzel Bakeries left in the country. Using the same techniques since we started in 1935, we've been twisting each delicious sourdough pretzel sourcing our ingredients from small farms in the Northeast.\n\nStop settling for mass-produced snacks that lack authenticity and quality. Instead, enjoy a flavorful, crunchy pretzel that’s free from preservatives, made with care, and steeped in history.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:44.741Z",
    importedBy: "entity-db-cli",
  },
};
